<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">车船轨迹查看</div>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <MapView ref="trackMap" MapKey="DefaultMap" MapLayers=" "></MapView>
          <div class="map_control">
            <div>
              <div class="play_control_panel">
                <input type="hidden" id="selCar" />
                <div class="follow_btn">
                  <el-checkbox v-model="checked">画面跟随</el-checkbox>
                </div>
                <div class="loadbutton" id="loadbutton" @click="handleLoadBtnClick">
                  <span>数据加载</span>
                </div>
                <div class="playbutton" id="playbutton" @click="handlePlay($event)">
                  <div class="playbutton_icon" :class="{ isPauseing:isPauseing}"></div>
                </div>
                <div id="divspeed" @click="divspeed($event)" class="fl speedbtn">
                  <div class="speedbutton_icon"></div>
                  <span class="speedbutton_text" id="spanspeed">1X</span>
                </div>
                <div class="fl resetbutton" id="resetbutton" @click="handleReset">
                   <div class="resetbutton_icon"></div>
                  <span>重置</span>
                </div>
              </div>
              <div class="progress_bar">
                <el-slider v-model="progress" :show-tooltip="false"></el-slider>
              </div>
            </div>
          </div>
          <div class="map_search_panel">
            <div>
              <el-form>
                <el-form-item label="开始日期">
                  <el-date-picker placeholder="选择日期" v-model="BeginTime"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker placeholder="选择日期" v-model="EndTime"></el-date-picker>
                </el-form-item>
              </el-form>
              <el-button class="search_btn" @click="handleSearch">查 询</el-button>
              <el-table
                v-loading="loading"
                :data="tableData"
                ref="multipleTable"
                border
                style="width: 100%"
                fixed
                @row-click="handleRowClick"
              >
                <el-table-column type="index" label="序号" width="80"></el-table-column>
                <el-table-column prop="CarName" label="车船名称"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import MapView from "./components/MapView";
import MyApis from "../../apis";

export default {
  name: "VehicleTrackView",
  componentName: "VehicleTrackView",
  components: {
    MapView,
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      ImagePath: "lib/zjmap/Content/images/track",
      progress: 0,
      checked: false,
      tableData: [],
      CarId: "",
      BeginTime: new Date(),
      EndTime: new Date(),
      loading: false,
      isPauseing: false, //播放是否暂停
      isPlayFinished: true,
      timer: null,
      pointsAll: new Array(), //轨迹点位
      index: 0, ////记录播放到第几个point
      car: null, //汽车图标,
      listLine: new Object(),
      arrayObjLine: new Array(),
      label: null, //信息标签
      cartype: 0, //当前是车还是船，车为1，船为2
      carShipName: "", //车辆名称
      playSpeed: 1000, //毫秒
      playSpeedZoom: 1.0, //播放倍率
      paramter: {},
      speed:1
    };
  },
  methods: {
    handleSearch() {
      this.search();
    },
    handleRowClick(row) {
      this.CarId = row.CarId;
      this.addPatrolPoint(row, row.DeviceType, row.CarName);
    },
    handleLoadBtnClick() {
      let that = this;
      if (!this.CarId) {
        this.$message({
          message: "请先选择车船",
          type: "warning",
        });
        return;
      }
      this.searchCarTrack()
        .then((r) => {
          var resData = r.data;
          if (!resData || !resData.RspCode || resData.RspCode != "1") {
            console.log(resData);
            this.$message({
              message: "获取轨迹出错",
              type: "error",
            });
            return;
          }

          if (
            !resData ||
            !resData.Data ||
            !resData.Data.PageContents ||
            resData.Data.PageContents.length == 0
          ) {
            console.log(resData);
            this.$message({
              message: "无轨迹信息",
              type: "info",
            });
            return;
          }

          var data = [];

          // eslint-disable-next-line no-undef
          $.each(resData.Data.PageContents, function (index, item) {
            data.push({
              id: item.CarId,
              lng: item.LatestLongitude,
              mlng: item.LatestLongitude,
              lat: item.LatestLatitude,
              mlat: item.LatestLatitude,
              sp: item.CurrentSpeed,
              hx: item.Angle,
              gt: item.LogTime,
            });
          });

          if (data != null && data.length > 0) {
            that.pointsAll = new Array();
            for (var i = 0; i < data.length; i++) {
              // eslint-disable-next-line no-undef
              var mappoint = new BMapGL.Point(data[i].mlng, data[i].mlat);
              that.pointsAll.push([
                mappoint,
                data[i].sp,
                that.setdirection(data[i].hx),
                data[i].gt,
                data[i].id,
                data[i].type,
              ]);
            }
            //超速
            if (that.pointsAll[0][1] >= 30) {
              // eslint-disable-next-line no-undef
              that.label = new BMapGL.Label(
                "<center><strong>" +
                  that.carShipName +
                  " | " +
                  that.pointsAll[0][1] +
                  "km/h" +
                  "</strong></center>" +
                  "时间: " +
                  that.pointsAll[0][3],
                // eslint-disable-next-line no-undef
                {
                  position: that.pointsAll[0][0],
                  // eslint-disable-next-line no-undef
                  offset: new BMapGL.Size(-50, -50),
                }
              );
              that.label.setStyle({
                color: "#FFF",
                border: "#ABABAB 1px solid",
                background: "#ec3c3c",
              });
            } else {
              // eslint-disable-next-line no-undef
              that.label = new BMapGL.Label(
                "<center><strong>" +
                  that.carShipName +
                  " | " +
                  that.pointsAll[0][1] +
                  "km/h" +
                  "</strong></center>" +
                  "时间: " +
                  that.pointsAll[0][3],
                // eslint-disable-next-line no-undef
                {
                  position: that.pointsAll[0][0],
                  // eslint-disable-next-line no-undef
                  offset: new BMapGL.Size(-50, -50),
                }
              );
              that.label.setStyle({
                color: "#FFF",
                border: "#ABABAB 1px solid",
                background: "#329c12",
              });
            }
            //alert(JSON.stringify(pointsAll[0][0]));
            if (that.cartype == "2") {
              // eslint-disable-next-line no-undef
              that.car = new BMapGL.Marker(that.pointsAll[0][0], {
                // eslint-disable-next-line no-undef
                icon: new BMapGL.Icon(
                  this.BASE_URL +
                    this.ImagePath +
                    "/boat/car" +
                    that.pointsAll[0][2] +
                    ".png",
                  // eslint-disable-next-line no-undef
                  new BMapGL.Size(60, 60),
                  // eslint-disable-next-line no-undef
                  { imageOffset: new BMapGL.Size(0, 0) }
                ),
              });
            } else {
              // eslint-disable-next-line no-undef
              that.car = new BMapGL.Marker(that.pointsAll[0][0], {
                // eslint-disable-next-line no-undef
                icon: new BMapGL.Icon(
                  this.BASE_URL +
                    this.ImagePath +
                    "/car/car" +
                    that.pointsAll[0][2] +
                    ".png",
                  // eslint-disable-next-line no-undef
                  new BMapGL.Size(60, 60),
                  // eslint-disable-next-line no-undef
                  { imageOffset: new BMapGL.Size(0, 0) }
                ),
              });
            }
            that.car.setLabel(that.label);

            var mapInstance = that.$refs.trackMap.mapInstance;
            var map = mapInstance.map;
            map.addOverlay(that.car);

            this.$message({
              message: "载入轨迹成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "无轨迹信息",
              type: "info",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            type: "error",
          });
        });
    },
    search() {
      let searchInfo = {
        //CarId: this.CarId,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        BeginTime:
          this.BeginTime == null
            ? "0001-01-01T00:00:00"
            : this.BeginTime.format("yyyy-MM-dd 0:00"),
        EndTime:
          this.EndTime == null
            ? "0001-01-01T00:00:00"
            : this.EndTime.format("yyyy-MM-dd 23:59"),
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };

      this.loading = true;
      new MyApis.TranResourcesApi()
        .GetCarShipInfoByTrail(searchInfo)
        .then((r) => {
          this.loading = false;
          r = r.data.Data;
          this.tableData = r.PageContents;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.$message({
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            type: "error",
          });
        });
    },
    searchCarTrack() {
      let searchInfo = {
        CarId: this.CarId,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        BeginTime:
          this.BeginTime == null
            ? "0001-01-01T00:00:00"
            : this.BeginTime.format("yyyy-MM-dd 0:00"),
        EndTime:
          this.EndTime == null
            ? "0001-01-01T00:00:00"
            : this.EndTime.format("yyyy-MM-dd 23:59"),
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      return new MyApis.TranResourcesApi().GetCarShipTrailHistory(searchInfo);
      // .then((r) => {
      //   r = r.data.Data;
      //   this.tableData = r.PageContents;
      //   this.total = r.BaseSearch.TotalCount;
      // })
      // .catch((e) => {
      //   console.log(e);
      //   this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      // });
    },
    drawLines: function () {
      this.$refs.trackMap.drawLines();
    },
    setdirection: function (d) {
      var direction = 0;
      if ((d >= 0) & (d < 22)) {
        direction = 0;
      } else if ((d >= 22) & (d < 45)) {
        direction = 1;
      } else if ((d >= 45) & (d < 67)) {
        direction = 2;
      } else if ((d >= 67) & (d < 90)) {
        direction = 3;
      } else if ((d >= 90) & (d < 112)) {
        direction = 4;
      } else if ((d >= 112) & (d < 135)) {
        direction = 5;
      } else if ((d >= 135) & (d < 157)) {
        direction = 6;
      } else if ((d >= 157) & (d < 180)) {
        direction = 7;
      } else if ((d >= 180) & (d < 202)) {
        direction = 8;
      } else if ((d >= 202) & (d < 225)) {
        direction = 9;
      } else if ((d >= 225) & (d < 249)) {
        direction = 10;
      } else if ((d >= 249) & (d < 272)) {
        direction = 11;
      } else if ((d >= 272) & (d < 300)) {
        direction = 12;
      } else if ((d >= 300) & (d < 322)) {
        direction = 13;
      } else if ((d >= 322) & (d < 345)) {
        direction = 14;
      } else if ((d >= 345) & (d < 367)) {
        direction = 15;
      } else if (d >= 367) {
        direction = 16;
      }
      return direction;
    },
    handlePlay: function () {
      var that = this;

      if (!that.pointsAll || that.pointsAll.length == 0) {
        this.$message({
          message: "未加载轨迹信息",
          type: "info",
        });
        return;
      }
      
      if (that.isPauseing) {
        if (that.isPlayFinished || that.isPauseing) {
          if (that.isPlayFinished) {
            that.clearCar();
          }
          that.isPlayFinished = false;
          that.isPauseing = false;
          that.play();
        }
      } else {
        that.isPauseing = true;
        that.pause();
      }
    },
    play: function () {
      let that = this;

      if (that.isPauseing || that.isPlayFinished) return;

      if (!that.pointsAll || that.pointsAll.length == 0) {
        this.$message({
          message: "未加载轨迹信息",
          type: "success",
        });
        return;
      }

      var point = that.pointsAll[that.index];
      var mapInstance = that.$refs.trackMap.mapInstance;
      var map = mapInstance.map;
      //clearCar();
      map.removeOverlay(that.car);

      if (that.index > 0) {
        // eslint-disable-next-line no-undef
        var polyLine = new BMapGL.Polyline(
          [that.pointsAll[that.index - 1][0], point[0]],
          {
            strokeColor: "red",
            strokeWeight: 4,
            strokeOpacity: 100,
          }
        );
        map.addOverlay(polyLine);
        that.listLine[that.index] = polyLine;
        that.arrayObjLine.push(that.index);
      }

      //超速
      if (point[1] >= 30) {
        // eslint-disable-next-line no-undef
        that.label = new BMapGL.Label(
          "<center><strong>" +
            that.carShipName +
            " | " +
            point[1] +
            "km/h" +
            "</strong></center>" +
            "时间: " +
            point[3],
          // eslint-disable-next-line no-undef
          { position: point[0], offset: new BMapGL.Size(-50, -50) }
        );
        that.label.setStyle({
          color: "#FFF",
          border: "#ABABAB 1px solid",
          background: "#ec3c3c",
        });
      } else {
        // eslint-disable-next-line no-undef
        that.label = new BMapGL.Label(
          "<center><strong>" +
            that.carShipName +
            " | " +
            point[1] +
            "km/h" +
            "</strong></center>" +
            "时间: " +
            point[3],
          // eslint-disable-next-line no-undef
          { position: point[0], offset: new BMapGL.Size(-50, -50) }
        );
        that.label.setStyle({
          color: "#FFF",
          border: "#ABABAB 1px solid",
          background: "#329c12",
        });
      }
      //label.setContent(point[4] + "<br>时间: " + point[3] + "<br>速度: " + point[1] + " km/h");
      if (that.cartype == "2") {
        // eslint-disable-next-line no-undef
        that.car = new BMapGL.Marker(point[0], {
          // eslint-disable-next-line no-undef
          icon: new BMapGL.Icon(
            this.BASE_URL + this.ImagePath + "/boat/car" + point[2] + ".png",
            // eslint-disable-next-line no-undef
            new BMapGL.Size(60, 60),
            // eslint-disable-next-line no-undef
            { imageOffset: new BMapGL.Size(0, 0) }
          ),
        });
      } else {
        // eslint-disable-next-line no-undef
        that.car = new BMapGL.Marker(point[0], {
          // eslint-disable-next-line no-undef
          icon: new BMapGL.Icon(
            this.BASE_URL + this.ImagePath + "/car/car" + point[2] + ".png",
            // eslint-disable-next-line no-undef
            new BMapGL.Size(60, 60),
            // eslint-disable-next-line no-undef
            { imageOffset: new BMapGL.Size(0, 0) }
          ),
        });
      }
      that.car.setLabel(that.label);
      map.addOverlay(that.car);

      that.index++;
      // eslint-disable-next-line no-undef
      if (that.checked) {
        map.centerAndZoom(point[0], 17);
        map.panTo(point[0]);
      }
      
      if (that.index < that.pointsAll.length) {
        that.timer = setTimeout(function () {
          that.progress = (that.index + 1 ) / that.pointsAll.length * 100;
          that.play();
        }, that.playSpeed * that.playSpeedZoom);
      } else {
        if (that.timer) {
          window.clearTimeout(that.timer);
        }
        that.index = 0;
        that.hkindex = 0;
        that.isPlayFinished = true;
        // eslint-disable-next-line no-undef
        $("#playbutton").attr(
          "src",
          this.BASE_URL + this.ImagePath + "/playicon/play.png"
        );
      }
    },
    addPatrolPoint: function (parm, type, carName) {
      this.paramter = parm;
      this.cartype = type;
      this.carShipName = carName;
      this.$message({
        message: "请点击数据加载按钮，加载车辆轨迹信息",
        type: "success",
      });
      this.reset(true);
      this.pointsAll = new Array();
    },
    divspeed: function (e) {
      var that = this;
      if (!that.pointsAll || that.pointsAll.length == 0) {
        this.$message({
          message: "未加载轨迹信息",
          type: "success",
        });
        return;
      }

      //var zoom = $(that).data("speed");
      that.playSpeedZoom = that.setSpeed(e.target); //zoom;

      if (that.isPlayFinished || that.isPauseing) {
        if (that.isPlayFinished) {
          that.clearCar();
        }
        that.isPlayFinished = false;
        that.isPauseing = false;
        // eslint-disable-next-line no-undef
        $("#playbutton").data("speed", 0);
        // eslint-disable-next-line no-undef
        $("#playbutton").attr(
          "src",
          this.BASE_URL + this.ImagePath + "/playicon/pause.png"
        );
        that.play();
      }
    },
    setSpeed: function (that) {
      // eslint-disable-next-line no-undef
      var speed = $(that).data("speed");
      var zoom = parseFloat(speed);
      switch (zoom) {
        case 0.5:
          // eslint-disable-next-line no-undef
          $(that).data("speed", 0.25);
          // eslint-disable-next-line no-undef
          $("#spanspeed").html("2X");
          return 0.5;
        case 0.25:
          // eslint-disable-next-line no-undef
          $(that).data("speed", 0.125);
          // eslint-disable-next-line no-undef
          $("#spanspeed").html("4X");
          return 0.25;
        case 0.125:
          // eslint-disable-next-line no-undef
          $(that).data("speed", 0.0625);
          // eslint-disable-next-line no-undef
          $("#spanspeed").html("8X");
          return 0.125;
        case 0.0625:
          // eslint-disable-next-line no-undef
          $(that).data("speed", 0.5);
          // eslint-disable-next-line no-undef
          $("#spanspeed").html("16X");
          return 0.0625;
      }
    },
    pause: function () {
      let that = this;
      if (that.timer) {
        window.clearTimeout(that.timer);
      }
    },
    handleReset: function () {
      let that = this;
      that.isPauseing = false;
      that.isPlayFinished = true;
      that.reset(false);
    },
    reset: function (isfirst) {
      let that = this;
      if (that.pointsAll.length == 0) {
        return;
      }

      var mapInstance = that.$refs.trackMap.mapInstance;
      var map = mapInstance.map;

      map.centerAndZoom(
        // eslint-disable-next-line no-undef
        new BMapGL.Point(106.90558576327307, 32.95535024374832),
        13
      );
      // eslint-disable-next-line no-undef
      that.checked = false;

      that.clearCar();
      // eslint-disable-next-line no-undef
      $("#playbutton").data("speed", 1);
      // eslint-disable-next-line no-undef
      $("#playbutton").attr(
        "src",
        this.BASE_URL + this.ImagePath + "/playicon/play.png"
      );
      // eslint-disable-next-line no-undef
      $("#quickbutton").data("speed", "0.5");
      // eslint-disable-next-line no-undef
      $("#quickbutton").attr(
        "src",
        this.BASE_URL + this.ImagePath + "/playicon/speed2.png"
      );

      that.isPlayFinished = true;
      if (that.timer) {
        window.clearTimeout(that.timer);
      }
      that.index = 0;

      map.removeOverlay(that.car);

      if (!isfirst) {
        //超速
        if (that.pointsAll[0][1] >= 30) {
          // eslint-disable-next-line no-undef
          that.label = new BMapGL.Label(
            "<center><strong>" +
              that.carShipName +
              " | " +
              that.pointsAll[0][1] +
              "km/h" +
              "</strong></center>" +
              "时间: " +
              that.pointsAll[0][3],
            // eslint-disable-next-line no-undef
            {
              position: that.pointsAll[0][0],
              // eslint-disable-next-line no-undef
              offset: new BMapGL.Size(-50, -50),
            }
          );
          that.label.setStyle({
            color: "#FFF",
            border: "#ABABAB 1px solid",
            background: "#ec3c3c",
          });
        } else {
          // eslint-disable-next-line no-undef
          that.label = new BMapGL.Label(
            "<center><strong>" +
              that.carShipName +
              " | " +
              that.pointsAll[0][1] +
              "km/h" +
              "</strong></center>" +
              "时间: " +
              that.pointsAll[0][3],
            // eslint-disable-next-line no-undef
            {
              position: that.pointsAll[0][0],
              // eslint-disable-next-line no-undef
              offset: new BMapGL.Size(-50, -50),
            }
          );
          that.label.setStyle({
            color: "#FFF",
            border: "#ABABAB 1px solid",
            background: "#329c12",
          });
        }

        // eslint-disable-next-line no-undef
        $("#scrollBarTxt").html(that.pointsAll[0][3]);

        if (that.cartype == "2") {
          // eslint-disable-next-line no-undef
          that.car = new BMapGL.Marker(that.pointsAll[0][0], {
            // eslint-disable-next-line no-undef
            icon: new BMapGL.Icon(
              this.BASE_URL +
                this.ImagePath +
                "/boat/car" +
                that.pointsAll[0][2] +
                ".png",
              // eslint-disable-next-line no-undef
              new BMapGL.Size(60, 60),
              // eslint-disable-next-line no-undef
              { imageOffset: new BMapGL.Size(0, 0) }
            ),
          });
        } else {
          // eslint-disable-next-line no-undef
          that.car = new BMapGL.Marker(that.pointsAll[0][0], {
            // eslint-disable-next-line no-undef
            icon: new BMapGL.Icon(
              this.BASE_URL +
                this.ImagePath +
                "/car/car" +
                that.pointsAll[0][2] +
                ".png",
              // eslint-disable-next-line no-undef
              new BMapGL.Size(60, 60),
              // eslint-disable-next-line no-undef
              { imageOffset: new BMapGL.Size(0, 0) }
            ),
          });
        }

        that.car.setLabel(that.label);
        map.addOverlay(that.car);
      }
      that.progress = 0;
    },
    clearCar: function () {
      let that = this;
      var mapInstance = that.$refs.trackMap.mapInstance;
      var map = mapInstance.map;
      //clearCar();
      map.removeOverlay(that.car);

      if (that.arrayObjLine != undefined && that.arrayObjLine.length > 0) {
        for (var i = 0; i < that.arrayObjLine.length; i++) {
          that.listLine[that.arrayObjLine[i]].hide;
          map.removeOverlay(that.listLine[that.arrayObjLine[i]]);
        }
        that.arrayObjLine = new Array();
      }
    },
  },
  created() {},
  mounted() {
    this.search();
    this.logInfo.ActionName = "车辆轨迹查看";
    this.logInfo.LogMessage = "车辆轨迹查看";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "车辆轨迹查看";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "Home",
  action: "VehicleTrack",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>